import React from "react";

interface NotificationModalProps {
  visible: boolean;
  onClose: () => void;
  type: "success" | "error";
  title: string;
  message: string;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  visible,
  onClose,
  type,
  title,
  message
}) => {
  if (!visible) return null;

  return (
    <div className="notification-modal-overlay" onClick={onClose}>
      <div className={`notification-modal ${type}`} onClick={(e) => e.stopPropagation()}>
        <div className="notification-icon">
          {type === "success" ? "✓" : "✗"}
        </div>
        <h3 className="notification-title">{title}</h3>
        <p className="notification-message">{message}</p>
        <button className="notification-button" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;

// Add CSS styles directly in this file using a template literal
const styles = `
.notification-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.notification-modal {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.notification-modal.success {
  /* border-left: 5px solid #28a745; */
  border-left: none !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  background: #fff;
}

.notification-modal.error {
  /* border-left: 5px solid #dc3545; */
  border-left: none !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  background: #fff;
}

.notification-icon {
  font-size: 48px;
  margin-bottom: 15px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.notification-modal.success .notification-icon {
  background-color: #d4edda;
  color: #28a745;
}

.notification-modal.error .notification-icon {
  background-color: #f8d7da;
  color: #dc3545;
}

.notification-title {
  margin: 0 0 15px 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.notification-message {
  margin: 0 0 25px 0;
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

.notification-button {
  padding: 10px 25px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.notification-button:hover {
  background-color: #0056b3;
}
`;

// Add styles to document head
const styleTag = document.createElement('style');
styleTag.innerHTML = styles;
document.head.appendChild(styleTag); 